import React, { useState } from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import VisibilitySensor from "react-visibility-sensor"
import { TwitterShareButton } from "react-share"
import t from "theme"

const SmartShare = ({ linkUrl, children, ...props }) => {
    const [isHidden, setHidden] = useState(true)

    return (
        <div
            css={css`
                position: relative;
            `}
            {...props}>
            {children}
            <VisibilitySensor onChange={setHidden}>
                <div
                    css={css`
                        position: absolute;
                        top: -${t.space[9]};
                        left: 0;
                    `}>
                    &nbsp;
                </div>
            </VisibilitySensor>

            <Revealable show={!isHidden}>
                <TwitterShareButton
                    css={css`
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        color: ${t.color.white};
                        font-weight: ${t.font.weight.semibold};
                        border-radius: 4px;
                        background-color: ${t.color.primary};
                        padding: ${t.space[1]} ${t.space[2]};
                    `}
                    url={"https://disruptionresearch.firebaseapp.com" + linkUrl}>
                    CLICK TO TWEET
                    <i
                        css={css`
                            margin-left: ${t.space[2]};
                            font-size: ${t.font.size[8]};
                        `}
                        className="icon-twitter"
                    />
                </TwitterShareButton>
            </Revealable>
        </div>
    )
}

export default SmartShare

const Revealable = styled("div")`
    position: absolute;
    bottom: ${t.space[3]};
    display: flex;
    width: 100%;
    justify-content: center;
    opacity: ${({ show }) => (show ? "0.8" : "0")};
    transition: opacity 0.3s ease-in;
    -moz-transition: opacity 0.3s ease-in;
    -webkit-transition: opacity 0.3s ease-in;
    :hover {
        opacity: ${({ show }) => (show ? "1" : "0")};
    }
`
